<template>
  <div class="supplier-product-form">
    <v-stepper v-model="step" vertical>
      <v-stepper-step
        :complete="step > 1"
        :color="
          step == 1
            ? 'primary'
            : $store.getters.supplierProductIsEdit
            ? 'grey'
            : 'success'
        "
        step="1"
        class="p-3 pb-0"
      >
        <span style="font-weight: 700"> مرحله اول</span>
        <v-row class="my-2 mx-1">
          <span class="mx-1 mt-1">
            یکی از حوزه‌های فعالیت خود را برای ثبت شناسنامه انتخاب کنید. برای
            راهنمایی بیشتر روی آیکون روبرو کلیک کنید
          </span>
          <HelperComponent helperId="select-category-and-product" />
        </v-row>
        <div v-if="step > 1">
          <label for="">حوزه فعالیت انتخاب شده : </label>
          <strong>
            {{ categorySelctedBreadCrumb }}
          </strong>
        </div>
      </v-stepper-step>

      <v-stepper-content step="1">
        <supplier-product-selecte-category-and-product
          @selectCategory="selectCategory"
          @selectBaseProductToCreateNewProd="selectBaseProductToCreateNewProd"
          @createNewProductWithNoBaseProduct="createNewProductWithNoBaseProduct"
          :categoryType="categoryType"
          :categoryTypeDisplayName="categoryTypeDisplayName"
          
        >
        </supplier-product-selecte-category-and-product>
      </v-stepper-content>
      <v-stepper-step
        :complete="step > 2"
        :color="step > 2 ? 'success' : 'primary'"
        step="2"
        class="p-3 pb-0"
      >
        مرحله دوم
        <v-row class="my-2 mx-1">
          <HelperComponent helperId="supplier-product-properties" />
          <small class="mx-1 mt-1">
            جزئیات ویژگیهای
            {{ categoryTypeDisplayName }}
          </small>
        </v-row>
      </v-stepper-step>
      <!-- :properties field related to Baseproduct properties
        :selectedProductProperties field related to supplierproduct properties
      -->
      <v-stepper-content step="2">
        <supplier-product-properties
          :categoryType="categoryType"
          :isSelectedProduct="isSelectedProduct"
          :properties="forEdit ? properties : selectedProduct.properties"
          @completeProductProperties="completeProductProperties"
          @goToCategoryStep="goToCategoryStep"
          :selectedProductProperties="
            forEdit ? productProperties : selectedProductProperties
          "
        >
        </supplier-product-properties>
      </v-stepper-content>
      <v-stepper-step
        :complete="step > 3"
        :color="step > 3 ? 'success' : 'primary'"
        step="3"
        class="p-3 pb-0"
      >
        مرحله سوم
        <v-row class="my-2 mx-1">
          <HelperComponent helperId="supplier-product-detail-form" />
          <small class="mx-1 mt-1">
            تعیین شرح و توضیحات {{ categoryTypeDisplayName }}
          </small>
        </v-row>
      </v-stepper-step>

      <v-stepper-content step="3">
        <supplier-product-detail-form
          :productTitleSuggestion="productTitleSuggestion"
          :isSelectedProduct="isSelectedProduct"
          :categoryType="categoryType"
          :selectedProduct="selectedProduct"
          :forEdit="forEdit"
          @goToPropertyStep="goToPropertyStep"
          @completeProductDetailData="completeProductDetailData"
          :categoryTypeDisplayName="categoryTypeDisplayName"
          :editActionName="editActionName"
          :createActionName="createActionName"
          :selesctedCategory="selesctedCategory"
        >
        </supplier-product-detail-form>
      </v-stepper-content>
      <v-stepper-step
        :complete="step > 4"
        :color="step > 4 ? 'success' : 'primary'"
        step="4"
        class="p-3 pb-0"
      >
        مرحله چهارم
        <v-row class="my-2 mx-1">
          <HelperComponent helperId="supplier-product-images" />
          <small class="mx-1 mt-1">
            تصاویر
            {{ categoryTypeDisplayName }}
          </small>
        </v-row>
      </v-stepper-step>

      <v-stepper-content step="4">
        <supplier-product-images
          @goToDetailStep="goToDetailStep"
          :productImages="images"
          :imagesFileIds="selectedProduct.imagesFileIds"
          @selectProductImages="selectProductImages"
          :categoryType="categoryType"
          ref="supplierProductImage"
        >
        </supplier-product-images>
      </v-stepper-content>
      <v-stepper-step
        v-if="categoryType == 'Product'"
        :complete="step > 5"
        :color="step > 5 ? 'success' : 'primary'"
        step="5"
        class="p-3 pb-0"
      >
        مرحله پنجم
        <v-row class="my-2 mx-1">
          <HelperComponent helperId="supplier-product-item-info" />
          <small class="mx-1 mt-1">
            اطلاعات تکمیلی
            {{ categoryTypeDisplayName }}
          </small>
        </v-row>
      </v-stepper-step>

      <v-stepper-content step="5">
        <supplier-product-item-info
          :categoryType="categoryType"
          ref="supplierProductItem"
          @goToImageStep="goToImageStep"
        >
        </supplier-product-item-info>
      </v-stepper-content>
    </v-stepper>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="closeForm()"> انصراف </v-btn>
      <v-btn
        v-if="
          (step > 3 &&
            categoryType != 'Product' &&
            categoryType != 'ElectronicDocument') ||
          step > 4
        "
        @click="createOrEditProduct()"
        color="primary"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
//این فرم برای سه حالت استفاده می‌شود -
//سک - ایجاد محصول از ابتدا
//دو-ویرایش محصول قبلاً ثبت شده
//سه - ایجاد محصول جدید از روی یک محصول ثبت شده موجود
//
//
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
const measurementQuantitiesRepository = RepoFactory.get(
  'measurementQuantities'
);
import Helper from '@/core/helpers';
import SupplierProductSelecteCategoryAndProduct from './SupplierProductSelecteCategoryAndProduct.vue';
import SupplierProductDetailForm from './SupplierProductDetailForm.vue';
import SupplierProductProperties from './SupplierProductProperties.vue';
import SupplierProductImages from './SupplierProductImages.vue';
import SupplierProductItemInfo from './SupplierProductItemInfo.vue';
export default {
  components: {
    SupplierProductSelecteCategoryAndProduct,
    SupplierProductDetailForm,
    SupplierProductProperties,
    SupplierProductImages,
    SupplierProductItemInfo,
  },
  props: {
    categoryType: {
      type: String,
      default: null,
    },
    categoryTypeDisplayName: {
      type: String,
      default: null,
    },
    //
    forEdit: {
      type: Boolean,
      defalut: false,
    },
    editActionName: {
      type: String,
      defalut: 'Unknown', //
    },
    properties: {
      type: Array,
      defalut: [],
    },
    productProperties: {
      type: Array,
      defalut: [],
    },
  },
  data() {
    return {
      selesctedCategory:null,
      selectedProduct: {
        productId: null,
        categoryId: null,
        name: null,
        summary: null,
        description: null,
        imagesFileIds: [],
        properties: [], // Base product props
        productProperties: [], //Supplier product props
        countingUnit: null,
        taxed: false,
        measurementUnitId: null,
        measurementUnitDisplayText: '',
        measurementUnitProperName: '',
        measurementQuantityId: null,
        measurementQuantityDisplayText: '',
        measurementQuantityProperName: '',
        units: [],
        minimumOrderVolume:1,
      },
      productTitleSuggestion: null,
      //All Post And Put Body
      productTemplate: {}, //بسته به نوع عملیات این مدل توسعه پیدا می‌کند در متدهای ایجاد، ویرایش، ایجاد محصول کسب و کار به همراه پایه و .. استفاده می‌شود
      categorySelctedBreadCrumb: null,
      images: [],
      step: 1,
      isSelectedProduct: false, // این متغیر را ابهام دارم برای چی هست؟
      //احتمالا برای دو حالت ویرایش یا ایجاد از روی یک محصول جدید مورد استفاده هست
      selectedProductProperties: [], //base product properties
      createActionName: 'unknown', // "NewProdNoBase"   "NewProdByBase"
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    if (this.forEdit) {
      this.selectedProduct.properties = this.properties;
      this.selectedProduct.productProperties = this.productProperties;
      let tempProductProperties = [];
      this.$store.getters.supplierProductSelectedForEdit.properties.forEach(
        (element) => {
          element.propertyId = element.propertyId;
          element.measurementUnitId = element.defaultMeasurementUnitId;
          element.measurementUnitItem = element.units;
          //  element.value = element.propertyType == 'File' ? [] : '';
          tempProductProperties.push(element);
          if (
            this.$store.getters.supplierProductSelectedForEdit &&
            this.$store.getters.supplierProductSelectedForEdit.properties
          ) {
            this.$store.getters.supplierProductSelectedForEdit.properties.forEach(
              (selectedProperty) => {
                if (selectedProperty.propertyId == element.propertyId) {
                  element.id = selectedProperty.id;
                  element.value =
                    element.propertyType == 'MultiSelectList'
                      ? selectedProperty.value.split('|')
                      : element.propertyType == 'Number'
                      ? selectedProperty.value.replace(/,/g, '')
                      : element.propertyType == 'File' && selectedProperty.value
                      ? [
                          {
                            fileId: selectedProperty.value,
                            thumbnailFileUrl: selectedProperty.fileValue
                              ? selectedProperty.fileValue.thumbnailFileUrl
                              : '',
                            fileUrl: selectedProperty.fileValue
                              ? selectedProperty.fileValue.fileUrl
                              : '',
                          },
                        ]
                      : element.propertyType == 'File' &&
                        !selectedProperty.value
                      ? []
                      : selectedProperty.value;
                  element.measurementUnitId =
                    selectedProperty.measurementUnitId;
                  element.maxValue = selectedProperty.maxValue;
                  element.setMaxValue = selectedProperty.maxValue
                    ? true
                    : false;
                }
              }
            );
          }
        }
      );
      //این خط قبلاً مارک بود باید چک کنیم اثراتشو
      //نباید مارک باشه برای افزودن ویژگیهای جددید گه ادمنی اضافه کرده
      //--------------------------------------
      //کاربرد این فابع برای افزودن ویژگیهای جدیدا اضافه شده توسط ادمین به دسته بندیها است
      // که قبلاً در زمان ایجاد محصول پایه یا محصول کسب و کار، وجود تداشتند
      // اینها باید در زمان ویرایش محصول کسب و کار به لیست ویژگیهای آنها اضافه شود تا شناسنامه کامل شود
      //مورد نیاز در حالت اعلام ویژگی پیشنهادی و قبول ادمین و ادامه ماجرا
      this.selectedProduct.properties = tempProductProperties;

      this.step = 2;

      //this.$store.getters.supplierProductIsEdit
      this.isSelectedProduct = true;
      // this.selectedProduct = this.$store.getters.supplierProductSelectedForEdit;
      // this.selectedProduct.imagesFileIds = [];
      // this.$store.getters.supplierProductSelectedForEdit.images.forEach(
      //   (element) => {
      //     this.selectedProduct.imagesFileIds.push(element.fileId);
      //   }
      // );
      // console.log("this.selectedproduct:")
      // console.log(this.selectedProduct)
      //چک شود این کد بعدی برای این هست که محصول از نو ایجاد شود یعنی ویرایش نباشد
    } else {
      this.step = 1;
      this.isSelectedProduct = false;
      // this.selectProductForAddingNewSupplierProduct(
      //   this.selectedProduct.categoryId
      // );
    }
    // this.selectProductForAddingNewSupplierProduct(
    //   this.selectedProduct.categoryId
    // );
  },
  beforeDestroy() {
    this.$store.commit('setSupplierProductSelectedForEdit', null);
    this.$store.commit('setSupplierProductIsEdit', false);
    this.$store.commit('setSupplierProductFormStatus', false);
  },
  methods: {
    goToCategoryStep() {
      this.selectedProduct = {};
      this.productTemplate.properties = [];
      this.step = 1;
    },
    goToPropertyStep() {
      this.step = 2;
    },
    goToDetailStep() {
      this.step = 3;
    },
    goToImageStep() {
      this.step = 4;
    },
    selectProductImages(product) {
      this.productTemplate.imagesFileIds = product.imagesFileIds;
      this.step = 5;
    },
    completeProductProperties(data) {
      this.productTemplate.properties = data.properties;
      if (data.propertySuggestions && data.propertySuggestions.length > 0) {
        this.productTemplate.propertySuggestions = data.propertySuggestions;
      }
      this.step = 3;
    },
    completeProductDetailData(product) {
      // alert(product.productProperties.length);
      const loader = this.$loading.show();

      this.productTemplate.description = product.description;
      this.productTemplate.summary = product.summary;
      this.productTemplate.taxed = product.taxed;
      this.productTemplate.measurementUnitId = product.measurementUnitId;
       this.productTemplate.minimumOrderVolume = product.minimumOrderVolume;
      if (!this.isSelectedProduct) {
        this.productTemplate.tags = product.tags;
        this.productTemplate.name = product.name;
      }
      if (this.$store.getters.supplierProductIsEdit) {
        this.productTemplate.description = product.description;
        this.productTemplate.summary = product.summary;
        this.productTemplate.taxed = product.taxed;
        this.productTemplate.name = product.name;
        this.productTemplate.measurementUnitId = product.measurementUnitId;
          this.productTemplate.minimumOrderVolume = product.minimumOrderVolume;
        // this.$store.getters.supplierProductSelectedForEdit.name;
        this.productTemplate.productId =
          this.$store.getters.supplierProductSelectedForEdit.productId;
        this.productTemplate.tags = product.tags;
        // this.$store.getters.supplierProductSelectedForEdit.tags;
        //this.productTemplate.properties = product.properties;
        //this.productTemplate.productProperties = product.productProperties;
        //this.selectedProduct.properties = product.properties;
        // this.selectedProduct.productProperties = product.productProperties;
        //selectedProduct
      }
      this.step = 4;

      loader.hide();
    },
    //اینجا با انتخاب شناسه دسته بندی فقط دسته بندی انتخاب شده ولی هنوز معلوم نیست آیا محصول پایه انتخاب کرده یا میخواد از اول ایجاد کنه
    //از اینجا فقط لیست ویژگیها را درمیاریم
    // ولی بعد باید ببینیم
    //در این حالت قطعاً طرف در حال ویرایش نیست
    selectCategory(categoryId, categorySelctedBreadCrumb) {
      this.getCategoryData(categoryId);
      this.productTemplate.categoryId = categoryId;
      this.selectedProduct.categoryId = categoryId;
      this.categorySelctedBreadCrumb = categorySelctedBreadCrumb;
      this.selectedProductProperties = [];
      //this.forEdit = false;
      this.isSelectedProduct = false;
    },
    //این باید برای ایجاد محصول تامین کننده از روی یک محصول ادمین یا پایه موجود فقط استفاده شود
    // این تابع از کامپوننت دیگری فراخوان شده و محصول به
    //ارسال می گردد
    // این ممکن است  محصول خود همین مرچنت برای ویرایش
    //یا محصول جدید برای  ثبت این مرچنت از روی محصول موجود دیگران باشد
    selectBaseProductToCreateNewProd(summaryProduct) {
      this.createActionName = 'NewProdByBase';
      //And the summaryProduct is BaseProduct
      if (summaryProduct == null) {
        return;
      }
      const loader = this.$loading.show();
      this.selectedProduct.properties = [];
      //Next step get baseProduct data by Id

      //
      //این تابع اطلاعات محصول پایه را برگشت میدهد
      //Get Base Product
      //این متد صرفاً برای ایجاد محصول کسب و کار از یک محصول پایه استفاده می‌شود
      //باید forEdit
      supplierProductRepository
        .getProductById(summaryProduct.id, this.productBaseUrl)
        .then((res) => {
          this.isSelectedProduct = true;

          //این تکه قاعدتا نباید اینجا کاربرد داشته باشد فعلاً کامنت می‌شود
          // if (this.forEdit) {
          //   this.$store.commit('setSupplierProductSelectedForEdit', res.data);
          //   this.isSelectedProduct = true;
          //   this.selectedProduct =
          //     this.$store.getters.supplierProductSelectedForEdit;
          //   this.selectedProduct.imagesFileIds = [];
          //   this.$store.getters.supplierProductSelectedForEdit.images.forEach(
          //     (element) => {
          //       this.selectedProduct.imagesFileIds.push(element.fileId);
          //     }
          //   );
          // }

          //  this.selectedProduct.productProperties = res.data.productProperties;
          this.selectedProduct.properties = res.data.properties;
          //this.selectedProductProperties = res.data.properties; //Base Product properties
          this.productTemplate.productId = res.data.id;
          this.selectedProduct.imagesFileIds = [];
          this.selectedProduct.description = res.data.description;
          this.selectedProduct.name = res.data.name;
          this.selectedProduct.summary = res.data.summary;
          this.selectedProduct.productId = res.data.id;
          this.selectedProduct.tags = res.data.tags;
           this.selectedProduct.minimumOrderVolume = res.data.minimumOrderVolume;
          this.images = res.data.images;
          this.productTemplate.tags = res.data.tags;
          //this.productTemplate.properties = res.data.properties;
          //this.productTemplate.propductProperties = res.data.productProperties;
          if (res.data.images && res.data.images.length) {
            res.data.images.forEach((element) => {
              this.selectedProduct.imagesFileIds.push(element.fileId);
            });
          }
          ///================================

          let tempProductProperties = [];

          supplierProductRepository
            .getProductAllProperties(res.data.categoryId, this.productBaseUrl)
            .then((response) => {
              response.data.forEach((element) => {
                if (element.forSupplier) {
                  element.propertyId = element.id;
                  element.measurementUnitId = element.defaultMeasurementUnitId;
                  element.mid = element.defaultMeasurementUnitId;
                  element.measurementUnitItem = element.units;
                  tempProductProperties.push(element);
                }
              });
              //this.selectedProduct.properties = tempProductProperties;
              this.selectedProduct.productProperties = tempProductProperties;
              this.selectedProductProperties = tempProductProperties;
              // this.step = 2;
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
              loader.hide();
            })
            .finally(() => {
              loader.hide();
            });

          //this.selectedProduct.properties = tempProductProperties;

          this.selectedProductProperties = tempProductProperties;

          ///==========================
          //Very important
          // this.$store.commit('setSupplierProductSelectedForEdit', this.productTemplate);
          this.isSelectedProduct = true;
          loader.hide();
          this.step = 2;
          // this.selectProductForAddingNewSupplierProduct(res.data.categoryId);
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    selectProductForAddingNewSupplierProduct(categoryId) {
      //برای ایجاد محصول از روی یک محصول پایه موجود
      if (categoryId == null) {
        alert(categoryId);
        return;
      }
      const loader = this.$loading.show();
      //The next Func Gets Properties by category Id (may from selected supplier product as Is)
      supplierProductRepository
        .selectProductForAddingNewSupplierProduct(
          categoryId,
          this.productBaseUrl
        )
        .then((response) => {
          let tempProductProperties = [];
          response.data.forEach((element) => {
            element.propertyId = element.id;
            element.measurementUnitId = element.defaultMeasurementUnitId;
            element.measurementUnitItem = element.units;
            element.value = element.propertyType == 'File' ? [] : '';
            tempProductProperties.push(element);
            if (
              this.$store.getters.supplierProductSelectedForEdit &&
              this.$store.getters.supplierProductSelectedForEdit.properties
            ) {
              this.$store.getters.supplierProductSelectedForEdit.properties.forEach(
                (selectedProperty) => {
                  if (selectedProperty.propertyId == element.id) {
                    element.id = selectedProperty.id;
                    element.value =
                      element.propertyType == 'MultiSelectList' &&
                      selectedProperty.value.length > 0
                        ? selectedProperty.value.split('|')
                        : element.propertyType == 'Number' &&
                          selectedProperty.value.length > 0
                        ? selectedProperty.value.replace(/,/g, '')
                        : element.propertyType == 'File' &&
                          selectedProperty.value
                        ? [
                            {
                              fileId: selectedProperty.value,
                              thumbnailFileUrl: selectedProperty.fileValue
                                ? selectedProperty.fileValue.thumbnailFileUrl
                                : '',
                              fileUrl: selectedProperty.fileValue
                                ? selectedProperty.fileValue.fileUrl
                                : '',
                            },
                          ]
                        : element.propertyType == 'File' &&
                          !selectedProperty.value
                        ? []
                        : selectedProperty.value;
                    element.measurementUnitId =
                      selectedProperty.measurementUnitId;
                    element.maxValue = selectedProperty.maxValue;
                    element.setMaxValue = selectedProperty.maxValue
                      ? true
                      : false;
                  }
                }
              );
            }
          });
          this.selectedProduct.properties = tempProductProperties;
          this.step = 2;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
    },
    createNewProductWithNoBaseProduct(categoryId) {
      this.createActionName = 'NewProdNoBase';

      this.isSelectedProduct = false;
      this.selectedProduct = {
        productId: null,
        categoryId: categoryId,
        name: null,
        summary: null,
        description: null,
        imagesFileIds: [],
        properties: [],
        countingUnit: null,
        taxed: false,
      };
      //قبلاً این دو خط پایینی بودند که کاممت شده آند
      // this.getProductAllProperties(this.productTemplate.categoryId);
      // this.getProductTitleSuggestion(this.productTemplate.categoryId);
      this.getProductAllProperties(categoryId);
      this.getProductTitleSuggestion(categoryId);
    },
    getProductTitleSuggestion(categoryId) {
      const loader = this.$loading.show();
      supplierProductRepository
        .getProductTitleSuggestion(
          this.productBaseUrl,
          {},
          {
            categoryId: categoryId,
          }
        )
        .then((response) => {
          this.productTitleSuggestion = response.data;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },

    getProductAllProperties(categoryId) {
      if (categoryId != null) {
        const loader = this.$loading.show();
        supplierProductRepository
          .getProductAllProperties(categoryId, this.productBaseUrl)
          .then((response) => {
            let tempProductProperties = [];
            response.data.forEach((element) => {
              element.propertyId = element.id;
              element.measurementUnitId = element.defaultMeasurementUnitId;
              element.mid = element.defaultMeasurementUnitId;
              element.measurementUnitItem = element.units;
              tempProductProperties.push(element);
              if (
                this.$store.getters.supplierProductSelectedForEdit &&
                this.$store.getters.supplierProductSelectedForEdit.properties
              ) {
                this.$store.getters.supplierProductSelectedForEdit.properties.forEach(
                  (selectedProperty) => {
                    if (selectedProperty.propertyId == element.id) {
                      element.id = selectedProperty.id;
                      element.value = selectedProperty.value;
                      element.measurementUnitId =
                        selectedProperty.measurementUnitId;
                      element.mid = selectedProperty.measurementUnitId;
                    }
                  }
                );
              }
            });
            //this.selectedProduct.properties = tempProductProperties;
            this.selectedProduct.productProperties = tempProductProperties;
            this.selectedProductProperties = tempProductProperties;
            //-----for sale munit
             console.log("get props data",response.data)
            this.selectedProduct.measurementUnitId =
              response.data.defaultMeasurementUnitId;
            this.selectedProduct.measurementUnitDisplayText =
              response.data.measurementUnitDisplayText;
            this.selectedProduct.measurementUnitProperName =
              response.data.measurementUnitProperName;
            this.selectedProduct.measurementQuantityId =
              response.data.measurementQuantityId;
            this.selectedProduct.measurementQuantityDisplayText =
              response.data.measurementQuantityDisplayText;
            this.selectedProduct.measurementQuantityProperName =
              response.data.measurementQuantityProperName;
            this.selectedProduct.units = response.data.units;
            ///
            this.step = 2;
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
     getCategoryData(categoryId) {
      if (categoryId != null) {
        const loader = this.$loading.show();
        supplierProductRepository
          .getCategoryData(categoryId, this.productBaseUrl)
          .then((res) => {
            this.selesctedCategory = res.data;
        
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    closeForm() {
      this.$store.commit('setSupplierProductSelectedForEdit', null);
      this.$store.commit('setSupplierProductIsEdit', false);
      this.$store.commit('setSupplierProductFormStatus', false);
      this.$router.push({
        path: `/supplier-products/${this.categoryType}`,
      });
    },
    createOrEditProduct() {
      // در اینجا دو تا متغیر مهم در نحوه ارسال هستند
      // this.createActionName
      // this.editActionName
      const loader = this.$loading.show();
      this.productTemplate.inventoryItemId = null;
      this.productTemplate.inventoryItemUnitId = null;
      this.productTemplate.availableQuantity = 0;
      this.productTemplate.price = 0;
      this.productTemplate.maximumOrderVolume =
        this.categoryType != 'Product' ||
        this.categoryType != 'ElectronicDocument'
          ? 0
          : 1;
      this.productTemplate.supplyType = 'Wholesale';
      this.productTemplate.productType =
        this.categoryType != 'Product'
          ? null
          : this.$refs.supplierProductItem.product.productType;
      if (this.categoryType != 'Product') {
        if (
          this.$refs.supplierProductImage.product.imagesFileIds &&
          this.$refs.supplierProductImage.product.imagesFileIds.length > 0
        ) {
          this.productTemplate.imagesFileIds =
            this.$refs.supplierProductImage.product.imagesFileIds;
          if (this.forEdit) {
            this.editSupplierProduct();
          } else if (this.isSelectedProduct) {
            this.createProductWithSelectedAdminProduct();
          } else {
            this.createProductAndSupplierProduct();
          }
          loader.hide();
        } else {
          loader.hide();
          this.$dialog.error({
            text: 'انتخاب عکس الزامی میباشد',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
        }
      } else {
        if (this.$store.getters.supplierProductIsEdit) {
          this.editSupplierProduct();
        } else if (this.isSelectedProduct) {
          this.createProductWithSelectedAdminProduct();
        } else {
          this.createProductAndSupplierProduct();
        }
        loader.hide();
      }
    },
    editSupplierProduct() {
      const loader = this.$loading.show();
      supplierProductRepository
        .editSupplierProduct(
          this.$store.getters.supplierProductSelectedForEdit.id,
          this.productTemplate,
          this.productBaseUrl,
          { MerchantId: this.merchantId }
        )
        .then((data) => {
          this.closeForm();
          loader.hide();
          this.$dialog.message.success('با موفقیت ویرایش گردید', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    createProductAndSupplierProduct() {
      const loader = this.$loading.show();
      supplierProductRepository
        .createSupplierProductWithProduct(
          this.productTemplate,
          this.productBaseUrl,
          {
            MerchantId: this.merchantId,
          }
        )
        .then((data) => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    createProductWithSelectedAdminProduct() {
      const loader = this.$loading.show();
      supplierProductRepository
        .createSupplierProduct(this.productTemplate, this.productBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((data) => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
  },
};
</script>

<style scoped>
.supplier-product-form {
  font-family: Iran Sans, yekan-regular !important;
}
</style>
